import { post_data } from "./functions";

export async function checkImageCreation(name) {
  const form = new FormData();
  form.append(
    "data",
    JSON.stringify({ function: "check_image_creation", name })
  );
  const response = await post_data("./includes/ajax.inc.php", form);
  return response;
}

export function createIframeForImageCreation(id) {
  const iframe = document.createElement("iframe");
  const basePath = location.href.split("/editor")[0];
  iframe.src = `${basePath}/pdf-for-image.php?id=${id}`;
  iframe.style.display = "none";
  document.body.appendChild(iframe);
}
